import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

const slide = keyframes`
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
`;

const TrustedBySection = () => {
    const companies = [
        'Align Technology',
        'LegalCraft',
        'Fanatics',
        'Exsegen',
        'British Telecom',
        'Makemytrip.com',
        'Innovaccer',
        'Snapmint',
        'Atlassian',
        'Delta AI',
        'TrueCounsel',
        'AtDawn',
    ];

    return (
        <Box
            component="section"
            sx={{
                py: 10,
                background: 'linear-gradient(to right, #f9fafb, white, #f9fafb)',
                borderTop: '1px solid #e5e7eb',
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        textAlign: 'center',
                        mb: 6,
                        fontSize: '1.875rem',
                    }}
                >
                    Trusted By
                </Typography>

                <Box
                    sx={{
                        width: '100%',
                        overflow: 'hidden',
                        maskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
                        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 8,
                            animation: `${slide} 30s linear infinite`,
                            width: 'fit-content',
                            '&:hover': {
                                animationPlayState: 'paused',
                            },
                        }}
                    >
                        {/* First set */}
                        {companies.map((company, index) => (
                            <Box
                                key={`first-${index}`}
                                sx={{
                                    flexShrink: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: 220,
                                    px: 2,
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '1.25rem',
                                        fontWeight: 500,
                                        color: '#9ca3af',
                                        letterSpacing: '0.3px',
                                        transition: 'all 0.3s ease',
                                        whiteSpace: 'nowrap',
                                        '&:hover': {
                                            color: '#10b981',
                                            fontWeight: 600,
                                        },
                                    }}
                                >
                                    {company}
                                </Typography>
                            </Box>
                        ))}
                        {companies.map((company, index) => (
                            <Box
                                key={`second-${index}`}
                                sx={{
                                    flexShrink: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: 220,
                                    px: 2,
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '1.25rem',
                                        fontWeight: 500,
                                        color: '#9ca3af',
                                        letterSpacing: '0.3px',
                                        transition: 'all 0.3s ease',
                                        whiteSpace: 'nowrap',
                                        '&:hover': {
                                            color: '#10b981',
                                            fontWeight: 600,
                                        },
                                    }}
                                >
                                    {company}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default TrustedBySection;